<template>
  <div>
    <button
      class="btn btn-default btn-sm pull-right"
      style="margin-top: 4px"
      :disabled="isTestInProgress"
      @click="performConnectivityTest"
    >
      <span class="fa fa-refresh" :class="{ 'fa-spin': isTestInProgress }" style="margin-right: 4px"></span>
      {{ testResultData ? "Re-test" : "Test" }}
    </button>
    <div style="margin-top: 5px">
      <b class="h5" :class="testStatusColorClass" style="font-weight: bold">
        {{ testResultTitle }} <span class="fa" :class="testStatusColorIcon"></span>
      </b>
      <p class="text-muted" style="margin: 0">{{ testStatusMessage }}</p>
    </div>
    <hr style="margin: 10px 0" />
    <transition name="expand">
      <div v-if="testResultData && !isTestInProgress" style="display: flex">
        <div style="display: flex; flex-direction: column">
          <span class="text-muted" style="text-transform: uppercase">Video</span>
          <span class="h3" style="margin: 0">
            {{ Math.floor(testResultData.video.bitrate / 1024) }}
            <small class="text-muted" style="font-size: 12px">kbps</small>
          </span>
          <span>{{ Math.floor(testResultData.video.packetLossRatio * 100) }}% packet loss</span>
        </div>
        <div style="display: flex; flex-direction: column; margin-left: 20px">
          <span class="text-muted" style="text-transform: uppercase">Audio</span>
          <span class="h3" style="margin: 0;">
            {{ Math.floor(testResultData.audio.bitrate / 1024) }}
            <small class="text-muted" style="font-size: 12px">kbps</small>
          </span>
          <span>{{ Math.floor(testResultData.audio.packetLossRatio * 100) }}% packet loss</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TEST_RESULT } from "../enums";
export default {
  name: "CallSettingsConnectivityTest",
  computed: {
    ...mapState("calls/connectivity", ["isTestInProgress", "testResult", "testResultMessage", "testResultData"]),
    /** Class to color status line */
    testStatusColorClass() {
      if (this.isTestInProgress || this.testResult === TEST_RESULT.READY) return "";
      return {
        "ev-text-success": this.testResult === TEST_RESULT.GOOD,
        "ev-text-warning": this.testResult === TEST_RESULT.OK,
        "ev-text-danger": [TEST_RESULT.POOR, TEST_RESULT.ERROR].includes(this.testResult)
      };
    },
    /** Class for status icon */
    testStatusColorIcon() {
      if (this.isTestInProgress) return ["fa-refresh", "fa-spin"];
      if (this.testResult === TEST_RESULT.READY) return ["fa-refresh"];
      return {
        "fa-thumbs-up": this.testResult === TEST_RESULT.GOOD,
        "fa-warning": this.testResult === TEST_RESULT.OK,
        "fa-exclamation-circle": [TEST_RESULT.PURE, TEST_RESULT.ERROR].includes(this.testResult)
      };
    },
    /** Connectivity status message */
    testStatusMessage() {
      if (this.isTestInProgress) return "Testing audio and video quality...";
      if (this.testResult === TEST_RESULT.READY) return "Ready to test audio and video quality.";
      return this.testResultMessage;
    },
    /** Connectivity status title */
    testResultTitle() {
      if (this.isTestInProgress) return "Connectivity test in progress";
      if (this.testResult === TEST_RESULT.READY) return "Ready to test";
      return `${this.testResult} Connectivity`;
    }
  },
  methods: {
    ...mapActions("calls/connectivity", ["performConnectivityTest"])
  }
};
</script>
